import { DEFAULT_LEGEND, LabelFormatOption, PieChartSpec, PieChartVisualOptions, UnitOptions } from '@/core';
import { OptionsEditorProps, PropToSpecMapping } from '@/plugin-system';
import { PieChartProps } from './PieChartPanel';

export const DEFAULT_DISPLAY = 'Default';
export const DEFAULT_SHOW_SERIES_NAME = true;
export const DEFAULT_COLOR_PALETTE = 'Categorical';

export const DEFAULT_VISUAL: PieChartVisualOptions = {
  show_series_name: DEFAULT_SHOW_SERIES_NAME,
  color_palette: DEFAULT_COLOR_PALETTE,
};

export const DEFAULT_UNIT: UnitOptions = { kind: 'Decimal', abbreviate: true };
export const DEFAULT_LABEL_FORMAT: LabelFormatOption = ['Percent'];
export const DEFAULT_AGGREGATION_PERCENT: number = 3;

export type PieChartOptionsEditorProps = OptionsEditorProps<PieChartSpec>;

/**
 * Creates the initial/empty options for a PieChart panel.
 */
export function createInitialPieChartSpec(): PieChartSpec {
  return {
    legend: DEFAULT_LEGEND,
    visual: DEFAULT_VISUAL,
    unit: DEFAULT_UNIT,
    label_format: DEFAULT_LABEL_FORMAT,
    aggregation_percent: DEFAULT_AGGREGATION_PERCENT,
  };
}

/**
 * Defines a mapping between a chart's props and its equivalent dashboard spec.
 * Keys represent the chart's props, while values correspond to the spec.
 */
export const PIE_CHART_PROP_TO_SPEC_MAPPING: PropToSpecMapping<PieChartProps, PieChartSpec> = {
  legend: 'legend',
  display: 'visual.display',
  showSeriesName: 'visual.show_series_name',
  colorPalette: 'visual.color_palette',
  labelFormat: 'label_format',
  unit: 'unit',
  percentDecimalPlaces: 'percent_decimal_places',
  aggregationPercent: 'aggregation_percent',
  overrides: 'overrides',
};
